import { LAST_VERIFIED } from '../officialSources';

/** Weather templates by region — not Everest data for every trek */
export const REGION_WEATHER = {
	everest: {
		label: 'Khumbu (Namche / Gorak Shep)',
		months: [
			{ month: 'Oct', highC: 12, lowC: -2, rainMm: 20, verdict: 'Peak season', trek: 'Excellent' },
			{ month: 'Nov', highC: 8, lowC: -6, rainMm: 5, verdict: 'Clear & cold', trek: 'Excellent' },
			{ month: 'Mar', highC: 14, lowC: 2, rainMm: 40, verdict: 'Spring', trek: 'Excellent' },
			{ month: 'Apr', highC: 16, lowC: 4, rainMm: 60, verdict: 'Rhododendron bloom', trek: 'Very good' },
			{ month: 'Jun', highC: 18, lowC: 10, rainMm: 250, verdict: 'Monsoon', trek: 'Avoid' },
			{ month: 'Jul', highC: 18, lowC: 11, rainMm: 350, verdict: 'Monsoon', trek: 'Avoid' },
		],
	},
	annapurna: {
		label: 'Annapurna (Pokhara / Manang)',
		months: [
			{ month: 'Oct', highC: 20, lowC: 8, rainMm: 40, verdict: 'Peak season', trek: 'Excellent' },
			{ month: 'Nov', highC: 16, lowC: 4, rainMm: 15, verdict: 'Clear skies', trek: 'Excellent' },
			{ month: 'Mar', highC: 18, lowC: 6, rainMm: 50, verdict: 'Spring', trek: 'Excellent' },
			{ month: 'Apr', highC: 22, lowC: 10, rainMm: 80, verdict: 'Warm, some haze', trek: 'Very good' },
			{ month: 'Jun', highC: 26, lowC: 16, rainMm: 400, verdict: 'Monsoon', trek: 'Avoid' },
			{ month: 'Jul', highC: 26, lowC: 18, rainMm: 600, verdict: 'Heavy rain', trek: 'Avoid' },
		],
	},
	langtang: {
		label: 'Langtang (Syabrubesi / Kyanjin)',
		months: [
			{ month: 'Oct', highC: 14, lowC: 0, rainMm: 30, verdict: 'Peak season', trek: 'Excellent' },
			{ month: 'Nov', highC: 10, lowC: -4, rainMm: 10, verdict: 'Cold & clear', trek: 'Very good' },
			{ month: 'Mar', highC: 12, lowC: 2, rainMm: 50, verdict: 'Spring', trek: 'Excellent' },
			{ month: 'Apr', highC: 14, lowC: 4, rainMm: 70, verdict: 'Rhododendron', trek: 'Very good' },
			{ month: 'Jun', highC: 16, lowC: 10, rainMm: 280, verdict: 'Monsoon', trek: 'Avoid' },
		],
	},
	manaslu: {
		label: 'Manaslu (Soti Khola / Larke)',
		months: [
			{ month: 'Oct', highC: 16, lowC: 2, rainMm: 35, verdict: 'Peak season', trek: 'Excellent' },
			{ month: 'Nov', highC: 12, lowC: -2, rainMm: 12, verdict: 'Clear & cold', trek: 'Very good' },
			{ month: 'Mar', highC: 14, lowC: 4, rainMm: 45, verdict: 'Spring', trek: 'Excellent' },
			{ month: 'Apr', highC: 18, lowC: 6, rainMm: 65, verdict: 'Good visibility', trek: 'Very good' },
			{ month: 'Jun', highC: 22, lowC: 12, rainMm: 300, verdict: 'Monsoon', trek: 'Avoid' },
		],
	},
	mustang: {
		label: 'Mustang (Jomsom / Lo Manthang)',
		months: [
			{ month: 'Mar', highC: 12, lowC: -2, rainMm: 15, verdict: 'Windy, dry', trek: 'Good' },
			{ month: 'Apr', highC: 16, lowC: 2, rainMm: 20, verdict: 'Spring', trek: 'Excellent' },
			{ month: 'Oct', highC: 14, lowC: 0, rainMm: 15, verdict: 'Peak season', trek: 'Excellent' },
			{ month: 'Nov', highC: 10, lowC: -4, rainMm: 8, verdict: 'Cold, clear', trek: 'Very good' },
			{ month: 'Jun', highC: 22, lowC: 10, rainMm: 30, verdict: 'Rain shadow — trekable', trek: 'Good' },
		],
	},
	dolpo: {
		label: 'Dolpo (Juphal / Phoksundo)',
		months: [
			{ month: 'Jun', highC: 18, lowC: 6, rainMm: 40, verdict: 'Best window opens', trek: 'Good' },
			{ month: 'Jul', highC: 20, lowC: 8, rainMm: 50, verdict: 'Monsoon but trekable', trek: 'Good' },
			{ month: 'Aug', highC: 20, lowC: 8, rainMm: 45, verdict: 'Late monsoon', trek: 'Good' },
			{ month: 'Sep', highC: 18, lowC: 4, rainMm: 30, verdict: 'Clearing skies', trek: 'Excellent' },
			{ month: 'Oct', highC: 14, lowC: 0, rainMm: 15, verdict: 'Peak season', trek: 'Excellent' },
		],
	},
	farEast: {
		label: 'Far East (Taplejung / Tumlingtar)',
		months: [
			{ month: 'Oct', highC: 16, lowC: 4, rainMm: 40, verdict: 'Peak season', trek: 'Excellent' },
			{ month: 'Nov', highC: 12, lowC: 0, rainMm: 15, verdict: 'Clear', trek: 'Very good' },
			{ month: 'Mar', highC: 14, lowC: 4, rainMm: 50, verdict: 'Spring', trek: 'Excellent' },
			{ month: 'Apr', highC: 18, lowC: 8, rainMm: 80, verdict: 'Warm', trek: 'Very good' },
			{ month: 'Jun', highC: 22, lowC: 14, rainMm: 350, verdict: 'Monsoon', trek: 'Avoid' },
		],
	},
	farWest: {
		label: 'Far West (Jumla / Rara)',
		months: [
			{ month: 'Oct', highC: 16, lowC: 2, rainMm: 25, verdict: 'Peak season', trek: 'Excellent' },
			{ month: 'Nov', highC: 12, lowC: -2, rainMm: 10, verdict: 'Cold & clear', trek: 'Very good' },
			{ month: 'Mar', highC: 14, lowC: 2, rainMm: 40, verdict: 'Spring', trek: 'Excellent' },
			{ month: 'Apr', highC: 18, lowC: 6, rainMm: 55, verdict: 'Good', trek: 'Very good' },
			{ month: 'Jun', highC: 22, lowC: 12, rainMm: 200, verdict: 'Monsoon', trek: 'Avoid' },
		],
	},
	valley: {
		label: 'Kathmandu Valley',
		months: [
			{ month: 'Oct', highC: 26, lowC: 12, rainMm: 50, verdict: 'Best weather', trek: 'Excellent' },
			{ month: 'Nov', highC: 22, lowC: 8, rainMm: 10, verdict: 'Clear & pleasant', trek: 'Excellent' },
			{ month: 'Mar', highC: 24, lowC: 10, rainMm: 30, verdict: 'Spring', trek: 'Excellent' },
			{ month: 'Apr', highC: 28, lowC: 14, rainMm: 50, verdict: 'Warm', trek: 'Very good' },
			{ month: 'Jun', highC: 28, lowC: 18, rainMm: 300, verdict: 'Monsoon', trek: 'Fair' },
			{ month: 'Jul', highC: 27, lowC: 19, rainMm: 400, verdict: 'Rainy', trek: 'Fair' },
		],
	},
	terai: {
		label: 'Terai lowlands (Chitwan / Lumbini / Janakpur)',
		months: [
			{ month: 'Oct', highC: 30, lowC: 18, rainMm: 40, verdict: 'Best season', trek: 'Excellent' },
			{ month: 'Nov', highC: 28, lowC: 14, rainMm: 10, verdict: 'Dry & warm', trek: 'Excellent' },
			{ month: 'Mar', highC: 32, lowC: 16, rainMm: 30, verdict: 'Warm', trek: 'Very good' },
			{ month: 'Apr', highC: 36, lowC: 20, rainMm: 50, verdict: 'Hot', trek: 'Good' },
			{ month: 'Jun', highC: 34, lowC: 24, rainMm: 350, verdict: 'Monsoon', trek: 'Fair' },
		],
	},
};

const REGION_MAP = {
	'Everest & Khumbu': 'everest',
	Annapurna: 'annapurna',
	'Langtang & Helambu': 'langtang',
	'Manaslu & Ganesh': 'manaslu',
	'Mustang & Dolpo': 'mustang',
	'Far East': 'farEast',
	'Far West': 'farWest',
	'Kathmandu Valley & short treks': 'valley',
	'Pilgrimage & culture': 'terai',
	'Wildlife & lowland': 'terai',
};

export function getWeatherForTrek(trek) {
	const key = REGION_MAP[trek.region] || 'annapurna';
	const template = REGION_WEATHER[key] || REGION_WEATHER.annapurna;
	return {
		source: `Regional climate data for ${template.label} — verify forecast before ${trek.title}.`,
		lastVerified: LAST_VERIFIED,
		regionLabel: template.label,
		months: template.months.map((m) => ({
			month: m.month,
			highC: m.highC,
			lowC: m.lowC,
			rainMm: m.rainMm,
			verdict: m.verdict,
			trek: m.trek,
		})),
		forecastLinks: [
			{ label: 'Mountain Forecast — Nepal', url: 'https://www.mountain-forecast.com/countries/Nepal' },
			{ label: 'DHM Nepal — Weather', url: 'https://dhm.gov.np/' },
		],
	};
}

/** Transport details by access mode */
export const ACCESS_TRANSPORT = {
	lukla: {
		domesticFlight: 'Kathmandu (TIA) → Lukla (LUA) — ~35 min. Airlines: Tara Air, Summit Air, Sita Air. Book round trip. USD 180–350 return (2026). Weather delays common — buffer 2–3 days in KTM.',
		roadAlternative: 'Drive KTM → Jiri / Phaplu → trek to Lukla area (adds 5–7 days). No flight needed.',
	},
	pokhara: {
		domestic: 'Kathmandu → Pokhara: 25-min flight (USD 60–120) or 6–8 hr tourist bus (NPR 800–1,500).',
		trailhead: 'Taxi or jeep from Pokhara Lakeside to trailhead.',
	},
	road: {
		domestic: 'Kathmandu to trailhead by jeep or local bus. Hire private jeep for comfort (USD 80–200 depending on distance).',
	},
	flight: {
		domestic: 'Domestic flight from Kathmandu or Pokhara to regional airport. Book early in peak season.',
	},
	heritage: {
		domestic: 'International flight to Kathmandu (TIA). Heritage sites are in the valley — taxi, ride-share, or walking between sites.',
	},
	safari: {
		domestic: 'Kathmandu → Chitwan/Bardia: 5–6 hr tourist bus, private car (4–5 hr), or 20-min flight to Bharatpur (Chitwan). Lodge usually arranges pickup.',
	},
};

/** Packing by max altitude band */
export function getPackingForTrek(trek, kind) {
	if (kind === 'heritage') {
		return [
			{ id: 'shoes', label: 'Comfortable walking shoes', category: 'Footwear', weight: '600g', buyAtHome: 'Any', rentKtm: 'N/A', needOct: true },
			{ id: 'modest', label: 'Modest temple clothing (cover shoulders & knees)', category: 'Clothing', weight: '400g', buyAtHome: 'Any', rentKtm: 'Buy locally', needOct: true },
			{ id: 'daypack', label: 'Daypack with water bottle', category: 'Gear', weight: '500g', buyAtHome: 'Any', rentKtm: 'N/A', needOct: true },
			{ id: 'cash', label: 'NPR cash for site tickets', category: 'Essentials', weight: '—', buyAtHome: 'ATM in Kathmandu', rentKtm: 'N/A', needOct: true },
			{ id: 'sun-hat', label: 'Sun hat & sunscreen', category: 'Health', weight: '100g', buyAtHome: 'Pharmacy', rentKtm: 'Pharmacy', needOct: true },
			{ id: 'rain', label: 'Light rain jacket (monsoon season)', category: 'Clothing', weight: '250g', buyAtHome: 'Any', rentKtm: '$2/day', needOct: false },
			{ id: 'adapter', label: 'Nepal plug adapter (Type C/D/M)', category: 'Electronics', weight: '50g', buyAtHome: 'Travel shop', rentKtm: 'Airport', needOct: true },
		];
	}
	if (kind === 'safari') {
		return [
			{ id: 'neutral', label: 'Neutral-coloured clothing (khaki, green, brown)', category: 'Clothing', weight: '500g', buyAtHome: 'Any', rentKtm: 'N/A', needOct: true },
			{ id: 'insect', label: 'Insect repellent (DEET 30%+)', category: 'Health', weight: '100g', buyAtHome: 'Pharmacy', rentKtm: 'Pharmacy', needOct: true },
			{ id: 'binoculars', label: 'Binoculars', category: 'Gear', weight: '600g', buyAtHome: 'Optics shop', rentKtm: 'Lodge may lend', needOct: false },
			{ id: 'hat', label: 'Sun hat', category: 'Clothing', weight: '80g', buyAtHome: 'Any', rentKtm: 'N/A', needOct: true },
			{ id: 'jacket', label: 'Light jacket for dawn safaris', category: 'Clothing', weight: '300g', buyAtHome: 'Any', rentKtm: 'N/A', needOct: true },
			{ id: 'shoes', label: 'Closed-toe shoes', category: 'Footwear', weight: '500g', buyAtHome: 'Any', rentKtm: 'N/A', needOct: true },
		];
	}

	const alt = parseInt(String(trek.maxAltitude).replace(/[^\d]/g, ''), 10) || 3000;
	const needsDown = alt >= 3500;
	const needsSleepingBag = alt >= 2500;

	return [
		{ id: 'boots', label: 'Broken-in hiking boots', category: 'Footwear', weight: '1.2 kg', buyAtHome: 'Outdoor shop', rentKtm: '$2/day', needOct: true },
		{ id: 'rain-shell', label: 'Waterproof rain jacket', category: 'Clothing', weight: '300g', buyAtHome: 'Any', rentKtm: '$2/day', needOct: true },
		...(needsSleepingBag ? [{ id: 'sleeping-bag', label: `Sleeping bag (${alt >= 4500 ? '-15°C' : '-5°C'} rated)`, category: 'Sleep', weight: '1.2 kg', buyAtHome: 'Outdoor', rentKtm: '$2/day', needOct: true }] : []),
		...(needsDown ? [{ id: 'down-jacket', label: 'Warm insulated jacket', category: 'Clothing', weight: '400g', buyAtHome: 'Outdoor', rentKtm: '$2/day', needOct: true }] : []),
		{ id: 'poles', label: 'Trekking poles', category: 'Gear', weight: '500g', buyAtHome: 'Outdoor', rentKtm: '$1/day', needOct: alt >= 3000 },
		{ id: 'water', label: 'Water bottles + purification', category: 'Gear', weight: '200g', buyAtHome: 'Tablets', rentKtm: 'Local', needOct: true },
		{ id: 'firstaid', label: 'First aid kit + blister plasters', category: 'Health', weight: '200g', buyAtHome: 'Pharmacy', rentKtm: 'Pharmacy', needOct: true },
		...(alt >= 3000 ? [{ id: 'diamox', label: 'Diamox (consult doctor)', category: 'Health', weight: '50g', buyAtHome: 'Prescription', rentKtm: 'Pharmacy', needOct: false }] : []),
	];
}

export function getTransportForAccess(access, trailhead) {
	const t = ACCESS_TRANSPORT[access] || ACCESS_TRANSPORT.road;
	return {
		summary: t.domestic || t.domesticFlight || '',
		trailhead: t.trailhead || `Road or flight to ${trailhead}.`,
		roadAlternative: t.roadAlternative || null,
	};
}
